export default __webpack_public_path__ + "static/media/vertical-dot.e06fead4.svg";